import styled from 'styled-components'

const ArrowContainer = styled.div`
  position: absolute;
  cursor: pointer;
  background-color: white;
  box-shadow: -1px 0px 20px rgba(0, 0, 0, 0.15);
  height: ${props => props.theme.size.M};
  width: ${props => props.theme.size.S};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const ArrowLeftContainer = styled(ArrowContainer)`
  left: 0;
`

export const ArrowRightContainer = styled(ArrowContainer)`
  right: 0;
`
